<script setup lang="ts">
import { computed, defineProps } from 'vue';
import { storeToRefs } from 'pinia';
import { SubscriptionType } from '@/dashboard/types/subscription';
import Button from '@/dashboard/vue/components/common/Button.vue';
import { usePurchaseStore } from '@/dashboard/store/purchaseStore';
import LoaderIcon from '@/dashboard/vue/components/icons/LoaderIcon.vue';

const props = defineProps<{
  type: SubscriptionType;
}>();

const purchaseStore = usePurchaseStore();
const { currentSubscription, selectedPlan, loading } = storeToRefs(purchaseStore);

const hasSubscription = computed(() => !!currentSubscription?.value);
const isCurrent = computed(() => {
  if (props.type == 'basic' && !hasSubscription.value) {
    return true;
  } else if (props.type == 'pro' && selectedPlan?.value?.id === currentSubscription?.value?.price_id) {
    return true;
  }

  return false;
});
</script>

<template>
  <Button v-if="isCurrent" class="button-outline-primary h-[64px] rounded-40">
    <span class="button__text text-buttons">Your Plan</span>
  </Button>

  <Button
    v-else-if="props.type === 'basic' && hasSubscription"
    :on-click="purchaseStore.cancelSubscription"
    :disabled="loading"
    class="button-ghost h-[64px] !rounded-40 outline-none"
  >
    <LoaderIcon v-if="loading" class="animate-spin stroke-black" />
    <span v-else class="button__text text-buttons">Downgrade</span>
  </Button>

  <Button
    v-else-if="props.type === 'pro' && !hasSubscription"
    :on-click="purchaseStore.goNext"
    :disabled="loading"
    class="button-colored h-[64px] !rounded-40 outline-none"
  >
    <LoaderIcon v-if="loading" class="animate-spin stroke-white" />
    <span v-else class="button__text text-buttons">Buy Now</span>
  </Button>

  <Button
    v-else-if="props.type === 'pro' && hasSubscription && !isCurrent"
    :on-click="purchaseStore.change"
    :disabled="loading"
    class="button-colored h-[64px] !rounded-40 outline-none"
  >
    <LoaderIcon v-if="loading" class="animate-spin stroke-white" />
    <span v-else class="button__text text-buttons">Change plan</span>
  </Button>
</template>
